import { Authority } from 'drive-ui-packages';
import { HTTP_STATUS_CODE, TWO_HUNDRED } from 'common/constants';
import { DropdownValue } from 'components/Dropdown/types';
import { ErrorResponse } from 'pages/AuthorizePaymentPage/interCompany/types';
import {
  PrinterAndCheckNoResponseType,
  PrinterConfig,
  PrinterErrors
} from './types';

export const getCheckTrayAndOverflowOptions = (
  selectedPrinter: string,
  printerDetails: PrinterConfig[],
  isCheckTray: boolean
): DropdownValue[] => {
  const selectedPrinterDetail = printerDetails.filter(
    printer => printer.printerDetails.printerName === selectedPrinter
  );
  if (selectedPrinterDetail.length && isCheckTray) {
    return Array.from(
      new Set(
        selectedPrinterDetail?.map(
          printerName => printerName.printerDetails.checkTray
        )
      )
    ).map(checkTray => ({
      label: checkTray,
      value: checkTray
    }));
  }
  if (selectedPrinterDetail.length && !isCheckTray) {
    return Array.from(
      new Set(
        selectedPrinterDetail?.map(
          printerName => printerName.printerDetails.overFlowTray
        )
      )
    )?.map(overFlowTray => ({
      label: overFlowTray,
      value: overFlowTray
    }));
  }
  return [];
};

export const getDefaultPrinter = (
  printersData: PrinterAndCheckNoResponseType[]
): DropdownValue[] =>
  printersData
    ?.filter(
      (printer, index, self) =>
        printer.isDefaultPrinter &&
        index ===
          self.findIndex(
            data =>
              data?.printerDetails?.printerName ===
              printer?.printerDetails?.printerName
          )
    )
    .map(defaultPrinter => ({
      label: defaultPrinter?.printerDetails?.printerName,
      value: defaultPrinter?.printerDetails?.printerName
    }));

export const getDefaultPrinterInfo = (
  printers: PrinterAndCheckNoResponseType[]
): PrinterAndCheckNoResponseType | undefined =>
  printers.find(printer => printer.isDefaultPrinter);

export const getDefaultStore = (
  printers: PrinterAndCheckNoResponseType[]
): DropdownValue | null => {
  const defaultPrinter = getDefaultPrinterInfo(printers);
  if (defaultPrinter) {
    const { printerName } = defaultPrinter.printerDetails;
    return {
      label: printerName,
      value: printerName
    };
  }
  return null;
};

export const isCheckNoExists = (data: ErrorResponse | null): boolean | null =>
  data &&
  HTTP_STATUS_CODE in data &&
  data.httpStatusCode !== TWO_HUNDRED &&
  data.issues[0].issue.includes('already exists');

export const mapPermissionsToAuthorities = (
  permissions: Authority[] | undefined
): string[] | undefined =>
  permissions?.map(({ authority }: Authority) => authority);

export const checkAuthorities = (
  authorities: string[] | undefined,
  authority: string
): boolean | undefined => authorities?.includes(authority);

export const getSelectedPrinter = (
  printers: PrinterAndCheckNoResponseType[] | undefined,
  defaultOption: DropdownValue
): PrinterAndCheckNoResponseType | undefined =>
  printers?.find(
    printer => printer.printerDetails?.printerName === defaultOption?.value
  );

export const getPrinterErrors = (
  defaultPrinter: PrinterAndCheckNoResponseType | undefined
): PrinterErrors => {
  if (!defaultPrinter) {
    return {
      printerError: true,
      checkTrayError: true,
      overflowTrayError: true
    };
  }
  const {
    printerDetails: { checkTray, overFlowTray, printerName }
  } = defaultPrinter;
  return {
    printerError: !printerName,
    checkTrayError: !checkTray,
    overflowTrayError: !overFlowTray
  };
};
